var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { IconBaseSvg } from "../icon-base";
var RotateLeftIcon = function (props) { return (React.createElement(IconBaseSvg, __assign({}, props, { viewBox: "0 0 24 24" }),
    React.createElement("g", { id: "Icon/ic_rotate_left", stroke: "none", strokeWidth: "1", fill: "inherit", fillRule: "evenodd" },
        React.createElement("path", { id: "ic_rotate_left_1", fill: "inherit", d: "M3.11,7.53 L1.7,6.11 C0.8,7.27 0.24,8.61 0.07,10 L2.09,10 C2.23,9.13 2.58,8.28 3.11,7.53 L3.11,7.53 Z M2.09,12 L0.07,12 C0.24,13.39 0.79,14.73 1.69,15.89 L3.1,14.47 C2.58,13.72 2.23,12.88 2.09,12 L2.09,12 Z M3.1,17.32 C4.26,18.22 5.61,18.76 7,18.93 L7,16.9 C6.13,16.75 5.29,16.41 4.54,15.87 L3.1,17.32 Z M9,3.07 L9,0 L4.45,4.55 L9,9 L9,5.09 C11.84,5.57 14,8.03 14,11 C14,13.97 11.84,16.43 9,16.91 L9,18.93 C12.95,18.44 16,15.08 16,11 C16,6.92 12.95,3.56 9,3.07 Z" })))); };
export default RotateLeftIcon;
//# sourceMappingURL=RotateLeftIcon.js.map